import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { postRequest } from "../services/apiMethods";
import BellDropdown from "./BellDropdown";

export default function Header() {
  const Navigate = useNavigate();
  const role = localStorage.getItem('role');
  const route = useLocation();

  const currentPath = window.location.pathname;

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: () => {
      return postRequest("/auth/logout");
    },
    onSuccess: (data) => {
      if(data?.statusCode == 200){
        localStorage.clear()
        window.location.href = "/";;
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const handleLogout = () => {
    mutate()
  }

  return (
    <>
      <header className="commn-header">
        <Navbar expand="lg" className="bg-body-tertiary">
          <Container fluid>
            <Navbar.Brand href="/" className="">
              <img
                src={require("../assets/images/SparkPro-logo.svg").default}
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                {role == "Customer" ?
                  <>
                    <button onClick={() => Navigate("/customer-dashboard")} className={currentPath == "/customer-dashboard" && "active"}>Dashboard </button>
                    <button onClick={() => Navigate("/your-enquiries")} className={currentPath == "/your-enquiries" && "active"}>Enquiries </button>
                    <button onClick={() => Navigate("/your-favourites")} className={currentPath == "/your-favourites" && "active"}>Favourites </button>
                    <button onClick={() => Navigate("/customer-account")} className={currentPath == "/customer-account" && "active"}>Account </button>
                    <button onClick={() => Navigate("/support")} className={currentPath == "/support" && "active"}>Help </button>

                    <button
                      onClick={handleLogout}

                    >
                      Logout
                    </button>
                  </>
                  : role == "Vendor" ?
                    <>
                      <button
                        onClick={() => Navigate("/dashboard")}
                        className={currentPath == "/dashboard" && "active"}
                      >
                        Dashboard
                      </button>
                      <button
                        onClick={() => Navigate("/leads")}
                        className={currentPath == "/leads" && "active"}
                      >
                        Leads
                      </button>
                      <button
                        onClick={() => Navigate("/responses")}
                        className={currentPath == "/responses" && "active"}
                      >
                        Responses
                      </button>

                      <button
                        onClick={() => Navigate("/settings")}
                        className={currentPath == "/settings" && "active"}
                      >
                        Account
                      </button>
                      <button
                        onClick={() => Navigate("/help-support")}
                        className={currentPath == "/help-support" && "active"}
                      >
                        Help
                      </button>
                      <button
                        onClick={handleLogout}

                      >
                        Logout
                      </button>
                 <BellDropdown/>
                    </>
                    : <>
                      {/* <button onClick={() => Navigate("/login")}>Log In</button>{" "}
                      <button onClick={() => Navigate("/pre-registration")}>Join as a Pro</button> */}
                      <button onClick={() => (window.location.href = "/login")}>Log In</button>
                      <button onClick={() => (window.location.href = "/join")}>Join as a Pro</button>

                    </>
                }








              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  );
}
